import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DataRoomShareableLink } from 'models/ShareableLink';
import ThreeDotsDropdown from 'components/ThreeDotsDropdown';
import { ALIGNMENT } from 'models/Global';
import {
  CreatedCell,
  NumberAcessCell,
  ProtectionCell,
  VisitsCell,
} from '../../../ShareableLinksTable/components';
import useGetShareableLinkActionOptions from '../../../../hooks/useGetShareableLinkActionOptions';

import './ShareableLinksMobileItem.styles.scss';

type ShareableLinksMobileItemProps = {
  className?: string;
  link: DataRoomShareableLink;
  showVisits?: boolean;
  updateShareableLink: (link: DataRoomShareableLink) => void;
  onRowClick: (link: DataRoomShareableLink) => void;
};

const ShareableLinksMobileItem: React.FC<ShareableLinksMobileItemProps> = (
  props,
) => {
  const {
    className,
    link,
    showVisits = false,
    updateShareableLink,
    onRowClick,
  } = props;
  const { name } = link;

  const classes = classNames('shareable-links-mobile-item', className);

  const { t } = useTranslation();

  const { options, prolongShareableLinkModal } =
    useGetShareableLinkActionOptions({ link, updateShareableLink });

  return (
    <div className={classes} onClick={() => onRowClick(link)}>
      <div className="row">
        <span className="name">{name}</span>
        <div className="actions" onClick={(e) => e.stopPropagation()}>
          <ThreeDotsDropdown
            renderAsPortal
            withBorder={false}
            alignment={ALIGNMENT.VERTICAL}
            options={options}
          />
        </div>
      </div>

      <NumberAcessCell link={link} />

      <div className="row">
        <div className="access">
          {t('created')}
          {' : '}
          <CreatedCell link={link} />
        </div>

        {showVisits && (
          <div className="access">
            {t('visitsUC')}
            {' : '}
            <VisitsCell link={link} />
          </div>
        )}
      </div>

      <ProtectionCell link={link} updateShareableLink={updateShareableLink} />

      {prolongShareableLinkModal}
    </div>
  );
};

export default ShareableLinksMobileItem;
